/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { ReactCompareSlider } from "react-compare-slider";
import { Caption, CosmosAsset, CosmosTagsAndAttribution } from "@components/elements";
import { CosmosCompareFragment } from "@cosmos/hygraph-schema";
import { CosmosCompareHandle } from "./CosmosCompareHandle";

const styles = css({
	"--asset-border-radius": `24px`,
});

const SliderStyles = css({
	"& img, video": {
		borderRadius: "eds.borderRadius.24",
		height: "100%",
		width: "100%",
		objectFit: "cover",
	},
	borderRadius: "eds.borderRadius.24",
	overflow: "hidden",
});

export type CosmosCompareProps = {
	className?: string;
} & CosmosCompareFragment;

export const CosmosCompare = ({
	className,
	leftImage,
	rightImage,
	caption,
	attribution,
}: CosmosCompareProps): React.JSX.Element | null => {
	if (!leftImage || !rightImage) {
		return null;
	}
	if (!attribution) {
		const attributions = [leftImage?.attribution, rightImage?.attribution].filter(Boolean);
		if (attributions?.length) {
			attribution = attributions.join(" | ");
		}
	}
	return (
		<VStack className={cx("cosmos-compare", "cosmos-compare-slider", styles, className)} width="full">
			<Caption caption={caption}>
				<CosmosTagsAndAttribution attribution={attribution}>
					<ReactCompareSlider
						itemOne={<CosmosAsset asset={leftImage} hideAttribution={true} />}
						itemTwo={<CosmosAsset asset={rightImage} hideAttribution={true} />}
						handle={<CosmosCompareHandle />}
						className={cx("cosmos-compare-rcs", SliderStyles)}
					/>
				</CosmosTagsAndAttribution>
			</Caption>
		</VStack>
	);
};
